<template>
  <div class="player-team">
    <div v-if="seasonType.player">
      <div class="tab-box">
        <ul class="tab-btn-list match">
          <li v-for="(tab, index) in tabList" :key="index" :class="{active:currentTab === index}"
              @click="tabIndexChange(currentTab)">
            <a href="#" @click.prevent="currentTab = index">{{ tab }}</a>
          </li>
        </ul>
      </div>

      <div v-if="gkStatus">
        <p class="title">GOALKEEPER</p>
        <div v-if="goalkeeperList.length" class="grid-list">
          <div v-for="(item, index) in goalkeeperList" :key="index" class="item">
            <router-link :to="{name: 'playerDetail', params: { id: item.player_id }}">
              <img :src="item.player_img" class="player-img" alt="player_goalkeeper">
              <div class="player-info">
                <p>{{item.player_no}}</p>
                <span class="name">{{item.k_name}}</span><span class="position">{{item.position}}</span>
              </div>
            </router-link>
          </div>
        </div>
        <div v-else class="empty-div">
          데이터가 없습니다.
        </div>
      </div>

      <div v-if="dfStatus">
        <p class="title">DEFENDER</p>
        <div v-if="defenderList.length" class="grid-list">
          <div v-for="(item, index) in defenderList" :key="index" class="item">
            <router-link :to="{name: 'playerDetail', params: { id: item.player_id }}">
              <img :src="item.player_img" class="player-img" alt="player_defender">
              <div class="player-info">
                <p>{{item.player_no}}</p>
                <span class="name">{{item.k_name}}</span><span class="position">{{item.position}}</span>
              </div>
            </router-link>
          </div>
        </div>
        <div v-else class="empty-div">
          데이터가 없습니다.
        </div>
      </div>

      <div v-if="mfStatus">
        <p class="title">MIDFIELDER</p>
        <div v-if="midfielderList.length" class="grid-list">
          <div v-for="(item, index) in midfielderList" :key="index" class="item">
            <router-link :to="{name: 'playerDetail', params: { id: item.player_id }}">
              <img :src="item.player_img" class="player-img" alt="player_midfielder">
              <div class="player-info">
                <p>{{item.player_no}}</p>
                <span class="name">{{item.k_name}}</span><span class="position">{{item.position}}</span>
              </div>
            </router-link>
          </div>
        </div>
        <div v-else class="empty-div">
          데이터가 없습니다.
        </div>
      </div>

      <div v-if="fwStatus">
        <p class="title">FORWARD</p>
        <div v-if="forwardList.length" class="grid-list">
          <div v-for="(item, index) in forwardList" :key="index" class="item">
            <router-link :to="{name: 'playerDetail', params: { id: item.player_id }}">
              <img :src="item.player_img" class="player-img" alt="player_forward">
              <div class="player-info">
                <p>{{item.player_no}}</p>
                <span class="name">{{item.k_name}}</span><span class="position">{{item.position}}</span>
              </div>
            </router-link>
          </div>
        </div>
        <div v-else class="empty-div">
          데이터가 없습니다.
        </div>
      </div>

      <!-- 군 입대 + 임대 데이터 없을 경우 아예 미 노출 -->
      <div v-if="emStatus && militaryList.length">
        <p class="title">군입대</p>
        <div class="grid-list">
          <div v-for="(item, index) in militaryList" :key="index" class="item moreDetail">
            <div class="img-div">
              <img :src="item.player_img" class="player-img no-mg" alt="player_forward">
              <div class="player-info">
                <span class="name">{{item.k_name}}</span><span class="position">{{item.position}} / {{item.etc_team}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="rtStatus && rentalList.length">
        <p class="title">임대</p>
        <div class="grid-list">
          <div v-for="(item, index) in rentalList" :key="index" class="item moreDetail">
            <div class="img-div">
              <img :src="item.player_img" class="player-img no-mg" alt="player_forward">
              <div class="player-info">
                <span class="name">{{item.k_name}}</span><span class="position">{{item.position}} / {{item.etc_team}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <PageComingSoon :titleText="' '" :descriptionText="String(seasonMsg)" />
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import PageComingSoon from '@/components/Common/PageComingSoon.vue';

export default {
  name: 'PlayerTeam',
  components: {PageComingSoon},
  data() {
    return {
      thisyear: dayjs().format('YYYY'),
      currentTab: 0,
      tabList: ['ALL', 'GK', 'DF', 'MF', 'FW'],
      goalkeeperList: [],
      defenderList: [],
      midfielderList: [],
      forwardList: [],
      militaryList: [],
      rentalList: [],
      gkStatus: true,
      dfStatus: true,
      mfStatus: true,
      fwStatus: true,
      emStatus: true,
      rtStatus: true,
      seasonType: this.$store.getters['getSeasonType'],
      seasonMsg: this.$store.getters['getSeasonMsg'],
    }
  },
  mounted () {
    this.getList();
  },
  methods: {
    tabIndexChange(val) {
      if(val === 0) {
        this.gkStatus = true;
        this.dfStatus = true;
        this.mfStatus = true;
        this.fwStatus = true;
        this.emStatus = true;
        this.rtStatus = true;
        return;
      }

      this.gkStatus = false;
      this.dfStatus = false;
      this.mfStatus = false;
      this.fwStatus = false;
      this.emStatus = false;
      this.rtStatus = false;
      if(val === 1) {
        this.gkStatus = true;
      } else if(val === 2) {
        this.dfStatus = true;
      } else if(val === 3) {
        this.mfStatus = true;
      } else if(val === 4) {
        this.fwStatus = true;
      }
    },
    async getList() {

      const {data} = await this.$http.get(`/player?year=${this.thisyear}`);
      if(data.success) {
        data.data.map(item => {
          // 임시 (onerror도 추가해야함)
          item.player_img = `https://www.dragons.co.kr/${item.player_img}`;

          if (item.etc === '군입대') {
            this.militaryList.push(item);
          } else if (item.etc === '임대') {
            this.rentalList.push(item);
          } else if (item.position === 'GK') {
            this.goalkeeperList.push(item);
          } else if (item.position === 'DF') {
            this.defenderList.push(item);
          } else if (item.position === 'MF') {
            this.midfielderList.push(item);
          } else if (item.position === 'FW') {
            this.forwardList.push(item);
          }
        });
      }
    }
  }
}
</script>
